import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-commercial-policiea',
  templateUrl: './commercial-policiea.component.html',
  styleUrls: ['./commercial-policiea.component.scss']
})
export class CommercialPolicieaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
